import { connect } from 'react-redux';
import { Dispatch } from 'redux';

import { State } from '../../typings/state';
import { TDispatchProps } from '../../typings/utils';
import { BatchesListState } from '../BatchesList/typings';
import { Order } from '../common/typings';
import {
    applySizesFilter,
    deleteCreative,
    hideCreativesSelector,
    hideDeleteConfirm,
    hideError,
    Html5CreativesAction,
    loadItems,
    saveName,
    setSelection,
    showCreativesSelector,
    showDeleteConfirm,
    submit,
    submitSizesSelection,
    toggleSizesSelection
} from '../Html5App/actions';

import { Html5Creatives } from './Html5Creatives';
import { FilterState, Html5CreativesProps, OwnProps } from './typings';

type DispatchProps = TDispatchProps<Html5CreativesProps, OwnProps>;
const mapDispatchToProps = (dispatch: Dispatch<Html5CreativesAction>): DispatchProps => {
    return {
        loadItems: (offset: number, order: Order, sizes: string[], filterText: string) =>
            dispatch(loadItems(offset, order, sizes, filterText)),
        applySizesFilter: (sizes: string[]) => dispatch(applySizesFilter(sizes)),
        setSelection: (id: string, selected: boolean) => dispatch(setSelection(id, selected)),
        saveName: (id: string, val: string) => dispatch(saveName(id, val)),
        hideError: () => dispatch(hideError()),
        delete: () => dispatch(deleteCreative()),
        toggleSizesSelection: (ids: number[], selected: boolean) => dispatch(toggleSizesSelection(ids, selected)),
        submitSizesSelection: () => dispatch(submitSizesSelection()),
        showDeleteConfirm: (id: string) => dispatch(showDeleteConfirm(id)),
        hideDeleteConfirm: () => dispatch(hideDeleteConfirm()),
        submit: (callback: (ids: number[]) => void) => dispatch(submit(callback)),
        showCreativesSelector: (id: string) => dispatch(showCreativesSelector(id)),
        hideCreativesSelector: () => dispatch(hideCreativesSelector())
    };
};

type StateProps = {
    filter: FilterState;
    batchesList: BatchesListState;
    error: { message: string } | undefined;
    isBusy: boolean;
    needRefresh: boolean;
};
export const mapStateToProps = (state: State): StateProps => {
    return {
        ...state.canvasEditor.html5.activeCreatives,
        error: state.canvasEditor.html5.error,
        isBusy: state.canvasEditor.html5.isBusy
    };
};

export const Html5CreativesContainer = connect<StateProps, DispatchProps, OwnProps>(
    mapStateToProps,
    mapDispatchToProps
)(Html5Creatives);
